export default "__VITE_ASSET__BI7sHRPq__ 100w";